export default __webpack_public_path__ + "images/backup-desc.jpg";